import {ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {MessageService} from 'primeng/api';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from '../cc-base.component';
import {FormFieldGroupConfig} from '../../model/api/form-field-group-config';
import {CcDetailComponent} from "./detail/cc-detail.component";
import {CcFormComponent} from "../form-dialog/form/cc-form.component";
import {takeUntil, timer} from "rxjs";

@Component({
  selector: 'app-cc-detail-dialog[formConfig]',
  templateUrl: './cc-detail-dialog.component.html',
  styleUrls: ['./cc-detail-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    TranslateService,
  ]
})
export class CcDetailDialogComponent<T = any> extends CcBaseComponent {

  @Input()
  formConfig: FormFieldGroupConfig[];

  @Input()
  dialogFormVisible: boolean = false;
  @Output()
  dialogFormVisibleChange = new EventEmitter<boolean>();

  @Input()
  dialogFormTitle: String = '';

  @Input()
  formRecord: any;

  @Input()
  transPartKey: String;

  @Input()
  fieldName: String;


  @Input()
  closeButtonLabel: String;

  recordName: string = '';

  @ViewChild('ccDetail')
  ccDetail: CcDetailComponent;

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit(): void {
    this.initConfigs();
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.initConfigs();
    });
  }

  protected initConfigs() {
    // this.cronField.tabs = this.cronTabs;
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  getRecordName() {
    if (this.formRecord) {
      // @ts-ignore
      const name = this.formRecord[this.fieldName];
      if (name) {
        return ' "' + name + '"';
      }
    }
    return '';
  }

  onShow() {
    timer(100)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => (document.activeElement as HTMLElement | null)?.blur());
    this.reloadFieldValueMap();
    this.dialogFormVisibleChange.emit(true);
  }

  showDialog(): void {
    this.dialogFormVisible = true;
    this.reloadFieldValueMap();
  }

  closeDialog(): void {
    this.dialogFormVisible = false;
    this.markForCheck();
  }

  public reloadFieldValueMap(): void {
    this.recordName = this.getRecordName();
    if(this.ccDetail)
      this.ccDetail.reloadFieldValueMap();
    this.markForCheck();
  }

}
